export default "__VITE_ASSET__CVCrFzss__"